import { KeyboardArrowDownRounded } from '@mui/icons-material';
import { Select as MuiSelect } from '@mui/material';
import { castArray } from 'lodash-es';
import { type FC, useEffect } from 'react';
import type { SelectProps } from './Select.types';

const Select: FC<SelectProps> = ({
  children,
  renderFloatingLabel = true,
  testPrefix,
  isFieldOptional,
  preSelectFirstOption,
  optionsCount,
  ...props
}) => {
  const isReadOnly = props?.inputProps?.readOnly || false;
  const label = props.label
    ? isFieldOptional
      ? `${String(props.label)} (optional)`
      : String(props.label)
    : '';

  useEffect(() => {
    // If there is only one option, the field is required, no value is selected,
    // the input is enabled, and a preSelect function is provided,
    // call preSelectFirstOption to pre-select the first option.
    const isRequiredAndEnabled = !isFieldOptional && !isReadOnly;
    if (preSelectFirstOption && optionsCount === 1 && !props?.value && isRequiredAndEnabled) {
      preSelectFirstOption();
    }
  }, [preSelectFirstOption, isFieldOptional, optionsCount, isReadOnly, props?.value]);

  return (
    <MuiSelect
      {...props}
      value={props.value || ''}
      label={renderFloatingLabel ? label : ''}
      fullWidth
      sx={[
        props.error
          ? {
              '&': {
                svg: {
                  path: {
                    stroke: (theme) => theme.palette.error.main,
                  },
                },
              },
            }
          : {},
        ...castArray(props.sx),
      ]}
      IconComponent={KeyboardArrowDownRounded}
      data-test={`${testPrefix}_wrapper`}
      inputProps={{
        autoComplete: 'off',
        readOnly: isReadOnly,
        'data-test': testPrefix,
      }}
      disabled={isReadOnly}
    >
      {children}
    </MuiSelect>
  );
};

export default Select;
